import {
    Box,
    chakra,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    Stack,
} from '@chakra-ui/react';

import AnnouncementCard from '../Components/AnnouncementCard';
import { ANNOUNCEMENTS } from '../Components/info_all_announcements';
import { ACTIVITIES } from '../Components/info_all_activities';
import { useLanguage } from '../i18n/LanguageContext';

const Activity = () => {
    const { t } = useLanguage();

    const Routing = (route) =>{
        window.location.href = route;
    }
    
    return (
        <Box
            bg="#edf3f8"
            p={{
                base: '5', 
                md: '20'
            }}
            w="auto"
        >
            <Box maxW="1100px" margin="auto">
                <chakra.h1
                    fontWeight="bold"
                    fontSize={{ base: 30, md: 36 }}
                    color="gray.700"
                    textAlign="left"
                    mb={6}
                >
                    {t('activity.pageTitle')}
                </chakra.h1>

                <Box as="section" mb={16}>
                    <chakra.h2
                        fontWeight="bold"
                        fontSize={32}
                        color="blue.400"
                        textAlign="left"
                        mb={2}
                    >
                        {t('news.title')}
                    </chakra.h2>
                    <chakra.p textAlign="left" color="gray.500" fontSize="sm" mb={6}>
                        {t('news.subtitle')}
                    </chakra.p>
                    {ANNOUNCEMENTS.length > 0 ? (
                        <Stack spacing={5}>
                            {ANNOUNCEMENTS.map((announcement) => (
                                <AnnouncementCard key={announcement.id} announcement={announcement} />
                            ))}
                        </Stack>
                    ) : (
                        <chakra.p color="gray.500" textAlign="left">
                            {t('news.empty')}
                        </chakra.p>
                    )}
                </Box>

                <Box as="section">
                    <chakra.h2
                        fontWeight="bold"
                        fontSize={32}
                        color="blue.400"
                        textAlign="left"
                        mb={2}
                    >
                        {t('activity.title')}
                    </chakra.h2>
                    <chakra.p textAlign="left" color="gray.500" fontSize="sm" mb={6}>
                        {t('activity.subtitle')}
                    </chakra.p>
                    <TableContainer bg="white" borderRadius="md" overflowX="auto">
                        <Table variant="simple" size="lg" w="100%" sx={{ tableLayout: 'fixed' }}>
                            <Thead bg="#4d8080">
                                <Tr>
                                    <Th w="15%" color="#eff5f5" fontSize="20" fontWeight="bold">
                                        {t('activity.date')}
                                    </Th>
                                    <Th w="25%" color="#eff5f5" fontSize="20" fontWeight="bold">
                                        {t('activity.topic')}
                                    </Th>
                                    <Th w="60%" color="#eff5f5" fontSize="20" fontWeight="bold">
                                        {t('activity.introduction')}
                                    </Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {ACTIVITIES.slice().reverse().map((activity, i) => (
                                    <Tr
                                        key={ACTIVITIES.length - i - 1}
                                        cursor="pointer"
                                        onClick={() => Routing(`/activity/${ACTIVITIES.length - i - 1}`)}
                                        _hover={{ bgColor: "#eff5f5", color: "#70a9a9" }}
                                    >
                                        <Td>{activity.date}</Td>
                                        <Td
                                            whiteSpace="normal"
                                            wordBreak="break-word"
                                            overflowWrap="anywhere"
                                        >
                                            {activity.title}
                                        </Td>
                                        <Td whiteSpace="normal" wordBreak="break-word">
                                            {activity.intro}
                                        </Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>
                </Box>
            </Box>
        </Box>
    )
}
export default Activity;
